var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3786 11.5571L17.7652 4.17041C18.5386 3.38375 19.7919 3.38375 20.5786 4.15708C21.0586 4.63708 21.2586 5.31708 21.1252 5.98375L19.8586 12.0904H27.3919C30.2586 12.0904 32.1919 15.0237 31.0719 17.6637L26.7252 27.8104C26.2986 28.7837 25.3386 29.4237 24.2719 29.4237H12.2719C10.8052 29.4237 9.60522 28.2237 9.60522 26.7571V13.4371C9.60522 12.7304 9.88522 12.0504 10.3786 11.5571ZM6.93856 26.7571C6.93856 28.2237 5.73856 29.4237 4.27189 29.4237C2.80522 29.4237 1.60522 28.2237 1.60522 26.7571V16.0904C1.60522 14.6237 2.80522 13.4237 4.27189 13.4237C5.73856 13.4237 6.93856 14.6237 6.93856 16.0904V26.7571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/Positive.0b4e08ed1e54a01a51c57a35bfef81dd.svg";
export { ForwardRef as ReactComponent };